import React from "react";

interface Props {
  roundValue: (val: number) => number;
  totalAmount: number;
  discount: number;
  deliveryFee: number;
  finalAmount: number;
  receivedBalance: number;
  remaining: number;
  outstandingAmount: number;
  paymentMethod: string;
  orderDate: string;
  orderTime: string;
  deliveryFeeEnabled: boolean;
}

const OrderPriceDetails: React.FC<Props> = ({
  roundValue,
  totalAmount,
  discount,
  deliveryFee,
  finalAmount,
  receivedBalance,
  remaining,
  outstandingAmount,
  paymentMethod,
  orderDate,
  orderTime,
  deliveryFeeEnabled,
}) => {
  const renderDetail = (label: string, value: string | number) => (
    <div className="flex justify-between px-2 my-2">
      <h2>{label}</h2>
      <h2 className="font-semibold">{value}</h2>
    </div>
  );

  return (
    <div className="laundry-order-price-details">
        {renderDetail("Sub total", roundValue(totalAmount).toFixed(2))}
        {renderDetail("Discount", roundValue(discount).toFixed(2))}
        {deliveryFeeEnabled && renderDetail("Delivery Fee", roundValue(deliveryFee).toFixed(2))}
        {renderDetail("Total Amount", roundValue(finalAmount).toFixed(2))}
        {renderDetail("Received Amount", roundValue(receivedBalance).toFixed(2))}
        {renderDetail("Remaining balance", roundValue(remaining).toFixed(2))}
        {renderDetail("Outstanding balance", roundValue(outstandingAmount).toFixed(2))}
        {renderDetail("Payment mode", paymentMethod)}
        {renderDetail("Order date & time", `${orderDate} & ${orderTime}`)}
        {/* {renderDetail("Order time", orderTime)} */}
    </div>
  );
};

export default OrderPriceDetails;